import { render } from "./OrderCancelled.vue?vue&type=template&id=a813fff2&scoped=true"
import script from "./OrderCancelled.vue?vue&type=script&lang=js"
export * from "./OrderCancelled.vue?vue&type=script&lang=js"

import "./OrderCancelled.vue?vue&type=style&index=0&id=a813fff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a813fff2"]])

export default __exports__